module.exports = __webpack_public_path__ + "img/danhuangrou.ea52397e.jpg";